<template>
    <div class="uni-max m-0" style="min-height: 100vh;">
        <div class="progress-bar"><div class="current-progress" :style="cssVars"></div></div>
        <transition name="fade" mode="out-in">
            <div key=1 v-if="step == 1" class="p-4 uni-max-xs mb-5">
                <div v-if="errors != 'null'" class="notice-error">{{ errors }}</div>
                <div v-else-if="notice != 'null'" class="notice-success">{{ notice }}</div>
                <div class="general-text-3">Step 1 / 3</div>
                <div class="general-text-2 pt-2 pb-4">How can we help you?</div>
                <div class="d-flex flex-column">
                    <button @click="ltype='sale'; step=2;" class="contact-tab-label h-auto mx-0 w-100 mb-3">Buy a Property</button>
                    <button @click="ltype='rent'; step=2;" class="contact-tab-label h-auto mx-0 w-100 mb-3">Rent a Property</button>
                </div>
            </div>
            <div key=2 v-else-if="step == 2"  class="p-4 uni-max-xs mb-5">
                <div class="general-text-3">Step 2 / 3</div>
                <div class="general-text-2 pt-2 pb-4">What is your requirement?</div>
                <div class="form-container-contact">
                    <label>Find Property for</label>
                    <select v-model="find_for" class="contact-select" name="enquiry[find_property_for]">
                        <option>Investment Purpose</option>
                        <option>Own Use</option>
                        <option>For Rent</option>
                        <option>Others</option>
                    </select>

                    <label>Your Budget</label>
                    <div class="position-relative">
                        <input type="number" v-model="budget" name="enquiry[budget]" style="padding-left: 45px;" required>
                        <span class="rm-tag">RM</span>
                    </div>
                    
                    <label>Property Category</label>
                    <select v-model="find_type" class="contact-select" name="enquiry[find_property_type]">
                        <option>Residential</option>
                        <option>Commercial</option>
                        <option>Industrial</option>
                        <option>Land</option>
                    </select>

                    <label>Property Type</label>
                    <div class="dropdown">
                        <button class="contact-select text-left" type="button" id="prop-type-drop" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {{ proptype }}
                        </button>
                        <div class="dropdown-menu proptype-dropdown" aria-labelledby="prop-type-drop">
                            <div class="dropdown-item" @click="proptype = 'All Types'">All Types</div>
                            <div class="dropdown-header">Landed</div>
                            <div class="dropdown-item" @click="proptype = 'Terrace'">Terrace</div>
                            <div class="dropdown-item" @click="proptype = 'Semi Detached'">Semi Detached</div>
                            <div class="dropdown-item" @click="proptype = 'Detached'">Detached</div>
                            <div class="dropdown-header">Highrise</div>
                            <div class="dropdown-item" @click="proptype = 'All Highrise'">All Highrise</div>
                        </div>
                    </div>

                    <label>Your Preferred Area*</label>
                    <input v-model="prefer" type="text" name="enquiry[preferred_area]" required placeholder="E.g: Butterworth">

                    <button @click="checkandNext" type="submit" class="btn contact-submit-btn mx-0">Continue to last step</button>
                    <div @click="step = 1" type="submit" class="btn m-0" style="background: none;">Back to previous step</div>
                </div>
            </div>
            <div key=3 v-else-if="step == 3"  class="p-4 uni-max-xs mb-5">
                <div class="general-text-3">Step 3 / 3</div>
                <div class="general-text-2 pt-2 pb-4">How can we contact you?</div>
                <form action="/enquiries" method="post" enctype="multipart/form-data" class="form-container-contact">
                    <label>Your Name</label>
                    <input type="text" name="enquiry[name]" required>

                    <label>Your Email Address</label>
                    <input type="email" name="enquiry[email]" required>

                    <label>Your Phone Number</label>
                    <input type="tel" name="enquiry[contact_number]" required>

                    <label>Remarks</label>
                    <textarea type="text" name="enquiry[message]" rows="5"></textarea>

                    <input type="hidden" name="enquiry[preferred_area]" :value="prefer">
                    <input type="hidden" name="enquiry[find_listing_type]" :value="find_type">
                    <input type="hidden" name="enquiry[find_property_type]" :value="proptype">
                    <input type="hidden" name="enquiry[budget]" :value="budget">
                    <input type="hidden" name="enquiry[find_property_for]" :value="find_for">
                    <input type="hidden" name="enquiry[enquiry_listing_attributes][listing_type]" :value="ltype">
                    <input type="hidden" name="enquiry[enquiry_type]" value="FIND_PROPERTY">
                    <input type="hidden" name="authenticity_token" :value="authtoken">

                    <div class="w-100 px-3">
                        <re-captcha :recaptcha_sitekey="recaptcha_sitekey">
                            <button type="submit" class="btn contact-submit-btn mx-0">Submit your request</button>
                        </re-captcha>
                    </div>
                    <div @click="step = 2" type="submit" class="btn m-0" style="background: none;">Back to previous step</div>
                </form>
            </div>
        </transition>
    </div>
</template>

<script>
import reCaptcha from '../reCaptcha.vue';

export default {
  components: { reCaptcha },
        name: "list-property",
        props:['authtoken', 'errors', 'notice', 'recaptcha_sitekey'],
        data() {
            return {
                step: 0,
                ltype: '',
                prefer: '',
                find_type: 'Residential',
                find_for: 'Investment Purpose',
                budget: '',
                proptype: 'All Types'
            };
        },
        computed: {
            cssVars() {
                return {
                    '--progress': (this.step/3 * 100) + '%',
                }
            }
        },
        mounted() {
            this.step = 1;
        },
        methods: {
            addComma: function(num) {
                var num_parts = num.toString().split(".");
                num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return num_parts.join(".");
            },
            checkandNext: function() {
                if (this.ltype && this.prefer && this.find_type && this.find_for && this.budget) {
                    this.step = 3;
                } else {
                    alert('Please fill in all the fields')
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
.progress-bar{
    width: 100%;
    height: 3px;
    background: none;
    position: sticky;
    position: -webkit-sticky;
    top: 60px;
    left: 0;

    .current-progress {
        transition: 0.3s all;
        width: var(--progress);
        height: 3px;
        background: var(--p4redsurface1, #D80000);
    }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.image-label {
  font-weight: bold;
  display: inline-block;
  text-align: left;
  padding: 0;
  color: #ECBC7B;
}

.rm-tag {
    position:absolute;
    top:15px;
    left:15px;
    font-size: 14px;
    color: var(--p4text1, #FFFFFF);
}

.proptype-dropdown {
    background: var(--p4surface1, #0F0F0F);
    border-radius: 0;
    width: 100%;

    .dropdown-header {
        color: #515151;
        font-size: 11px;
    }

    .dropdown-item {
        padding: 10px 20px;
        color: var(--p4text1, #FFFFFF);
        cursor: pointer;

        &:hover {
            background: var(--p4surface5, #1C1C1C);
            color: var(--p4redsurface1, #D80000);
        }
    }
}

@media (max-width: 991px) {
    .progress-bar{
        top: 72px;
    }

    .proptype-dropdown {
        box-shadow: 0px 0px 300px 40px rgba(0,0,0,0.75);
        -webkit-box-shadow: 0px 0px 300px 40px rgba(0,0,0,0.75);
        -moz-box-shadow: 0px 0px 300px 40px rgba(0,0,0,0.75);
        position: fixed !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
        width: 80%;
        max-width: 400px;
    }
}
</style>